/* eslint-disable @typescript-eslint/no-explicit-any */
import { FetchArgs as BaseFetchArgs } from '@reduxjs/toolkit/dist/query/fetchBaseQuery';
import { fetchBaseQuery, FetchBaseQueryMeta } from '@reduxjs/toolkit/dist/query/react';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { BaseQueryFn } from '@reduxjs/toolkit/src/query/baseQueryTypes';
import { TCHOP_ROOT_URL } from '../../env';
import { prepareHeaders, resolveBaseUrl } from '../helpers';
import { GraphqlExtensionPersistedQuery } from './buildPersistedQueryExtension';

export type GraphqlFetchVariables = Record<string, unknown>;

interface GraphqlFetchArgs extends Omit<BaseFetchArgs, 'body'> {
  body:
    | {
        extensions?: { persistedQuery: GraphqlExtensionPersistedQuery };
        variables?: GraphqlFetchVariables;
        query: string;
      }
    | {
        extensions: { persistedQuery: GraphqlExtensionPersistedQuery };
        variables?: GraphqlFetchVariables;
      };
}

export const graphqlFetchBaseQuery = fetchBaseQuery({
  baseUrl: resolveBaseUrl('/api', TCHOP_ROOT_URL),
  prepareHeaders,
  credentials: 'include',
}) as BaseQueryFn<GraphqlFetchArgs, any, FetchBaseQueryError, unknown, FetchBaseQueryMeta>;
